export default {
      id: "deco_alu-usage",
      viewBox: "0 0 350 355",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_alu-usage",
      toString: function () {
        return this.url;
      }
    }